window.addEventListener('load', function () {
  document.querySelector('.preloader').style.display = 'none'
})
